/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettlementTabsEnum {
    ALL = 'ALL',
    TODO = 'TODO',
}
